export enum LocationInputMode {
  DEFAULT = 'DEFAULT',
  MAP = 'MAP',
  DRAG = 'DRAG',
  DUPLICATE = 'DUPLICATE',
  SELECT = 'SELECT',
}
